var React = require('react');

function Train (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M376 96H72a24 24 0 0 0-24 24v112a24 24 0 0 0 24 24h304a24 24 0 0 0 24-24V120a24 24 0 0 0-24-24zm5 401.72L318 448H130l-63 49.72A8 8 0 0 0 72 512h304a8 8 0 0 0 5-14.28z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M130 448h188c68.4 0 130-44.19 130-96V96c0-53-63-96-128-96H128C64 0 0 43 0 96v256c0 52 61.82 96 130 96zm94-40a56 56 0 1 1 56-56 56 56 0 0 1-56 56zM48 120a24 24 0 0 1 24-24h304a24 24 0 0 1 24 24v112a24 24 0 0 1-24 24H72a24 24 0 0 1-24-24z","className":"fa-primary","key":2})]);
}

Train.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Train;

Train.default = Train;
